module.exports = __webpack_public_path__ + "img/lucky5ex_icon.e52b4ed3.png";